import React, { useEffect, useState, useRef } from 'react';
import axios from "axios";
import { API_BASE_URL } from "../../global";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Tooltip } from 'react-tooltip';
import Iframe from 'react-iframe';

import '@react-pdf-viewer/core/lib/styles/index.css';
import * as pdfjsLib from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export function parsePageRangeString(range) {
  if (!range) return [];
  const pages = new Set();
  String(range)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .forEach((part) => {
      if (part.includes("-")) {
        const [start, end] = part.split("-").map((n) => parseInt(n.trim(), 10));
        if (!isNaN(start) && !isNaN(end)) {
          const lo = Math.min(start, end);
          const hi = Math.max(start, end);
          for (let i = lo; i <= hi; i++) pages.add(i);
        }
      } else {
        const num = parseInt(part, 10);
        if (!isNaN(num)) pages.add(num);
      }
    });
  return Array.from(pages).sort((a, b) => a - b);
}


const PDFCanvasViewerbkp = ({ fileUrl, pageRange = '1', scale = 1.5 }) => {
  const containerRef = useRef();
  const [zoom, setZoom] = useState(scale);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const renderPages = async () => {
      if (!fileUrl) return;
      setLoading(true);
      try {
        // const loadingTask = pdfjsLib.getDocument(fileUrl);
        const loadingTask = pdfjsLib.getDocument({
          url: fileUrl,
          withCredentials: false,
        });
        const pdf = await loadingTask.promise;

        const container = containerRef.current;
        container.innerHTML = '';

        let pages = [];
        if (typeof pageRange === 'string' && pageRange.includes('-')) {
          const [start, end] = pageRange.split('-').map(Number);
          pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        } else {
          const num = parseInt(pageRange, 10);
          if (!isNaN(num)) pages = [num];
        }

        for (const pageNum of pages) {
          if (pageNum < 1 || pageNum > pdf.numPages) continue;

          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: zoom });

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: ctx, viewport }).promise;

          // if (!cancelled) container.appendChild(canvas);
          if (!cancelled) {
            container.appendChild(canvas);

            // Create page number element
            const pageNumberDiv = document.createElement('div');
            pageNumberDiv.style.textAlign = 'center';
            pageNumberDiv.style.marginTop = '8px';
            pageNumberDiv.innerHTML = `Page ${pageNum} of ${pdf.numPages}`;
            container.appendChild(pageNumberDiv);
          }
        }
      } catch (error) {
        console.error("Error rendering PDF pages:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    renderPages();

    return () => {
      cancelled = true;
    };
  }, [fileUrl, pageRange, zoom]);

  return (
    <div>
      {loading && (
        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
          <span>Loading PDF...</span>
        </div>
      )}
      <div ref={containerRef} style={{ display: 'flex', flexDirection: 'column', gap: '24px', opacity: loading ? 0 : 1 }} />

    </div>
  );
};

export const PDFCanvasViewer = ({ fileUrl, caseId, pageRange = '1', scale = 1.5 }) => {
  const containerRef = useRef();
  const [zoom, setZoom] = useState(scale);
  const [loading, setLoading] = useState(false);
  const [pdfPages, setPdfPages] = useState([]);

  console.log("soorya", pageRange)

  useEffect(() => {
    if (!caseId) return;

    const pagesToFetch = parsePageRangeString(pageRange);
    if (pagesToFetch.length === 0) return;

    const fetchPages = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${API_BASE_URL}get_pages`,
          {
            case_id: caseId,
            pages: pagesToFetch,
          }
        );

        if (response.data.status === 1) {
          setPdfPages(response.data.pdf_pages);
        } else {
          console.error('API error:', response.data.message);
          setPdfPages([]);
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setPdfPages([]);
      }
    };

    fetchPages();
  }, [caseId, pageRange]);

  // Render PDF pages whenever pdfPages or zoom changes
  useEffect(() => {
    let cancelled = false;

    const renderPages = async () => {
      if (!pdfPages.length) return;
      const container = containerRef.current;
      if (!container) return;

      container.innerHTML = ''; // Clear previous content

      for (const pageData of pdfPages) {
        const { page_url, page_no } = pageData;

        try {
          const loadingTask = pdfjsLib.getDocument({
            url: page_url,
            withCredentials: false,
          });

          const pdf = await loadingTask.promise;
          const page = await pdf.getPage(1);
          const viewport = page.getViewport({ scale: zoom });

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: ctx, viewport }).promise;

          if (cancelled) return;

          container.appendChild(canvas);

          const pageNumberDiv = document.createElement('div');
          pageNumberDiv.style.textAlign = 'center';
          pageNumberDiv.style.marginTop = '8px';
          pageNumberDiv.innerHTML = `Page ${page_no}`;
          container.appendChild(pageNumberDiv);
          setLoading(false);
        } catch (error) {
          console.error(`Error rendering page ${pageData.page_no}:`, error);
        }
      }
    };

    renderPages();

    return () => {
      cancelled = true;
    };
  }, [pdfPages, zoom]);

  return (
    <div>
      {loading && (
        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
          <span>Loading PDF...</span>
        </div>
      )}
      <div ref={containerRef} style={{ display: 'flex', flexDirection: 'column', gap: '24px', opacity: loading ? 0 : 1 }} />

    </div>
  );
};


const ReportPdf = ({ toggleSidebar2, pdf, caseName, case_id, type = 2, searchitempage = 1 }) => {
  const iframeRef = useRef(null);

  const [iframeKey, setIframeKey] = useState(Date.now());

  const handleIframeLoad = () => {
    // Smooth scroll the page to the top
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // If you also want to scroll the iframe into view in case it's far down the page:
    if (iframeRef.current) {
      iframeRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };


  function randomPrefix() {
    return Math.floor(100 + Math.random() * 900); // 3-digit random prefix
  }

  // Recreate iframe when pdf changes to reset scroll position
  useEffect(() => {
    setIframeKey(Date.now());
  }, [pdf]);

  const downloadpdf = async (url, caseName = 'Original_document', case_id = '1') => {
    const pdfUrl = url;
    try {
      const response = await axios.post(`${API_BASE_URL}download_pdf`, { pdf_url: pdfUrl }, {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' },
      });
      const pdfBlob = response.data;
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const zip = new JSZip();
      const pdffileName = `${randomPrefix()}${case_id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      zip.file(`${pdffileName}.pdf`, pdfBlob);
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const fileName = `${randomPrefix()}${case_id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      saveAs(zipBlob, `${fileName}.zip`);
    } catch (err) {
      console.error("Error downloading and zipping PDF:", err);
      window.open(pdfUrl, "_blank");
    }
  };

  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);

  useEffect(() => {
    if (type === 1 && pdf) {
      // const fetchPdfBlob = async () => {
      // try {
      //   setLoadingPdf(true);
      //   const response = await axios.post(`${API_BASE_URL}download_pdf`, { pdf_url: pdf }, {
      //     responseType: 'blob',
      //     headers: { 'Content-Type': 'application/json' },
      //   });
      //   const blobUrl = URL.createObjectURL(response.data);
      //   setPdfBlobUrl(blobUrl);

      // } catch (error) {
      //   console.error("Failed to fetch PDF blob:", error);
      // } finally {
      //   setLoadingPdf(false);
      // }
      // };
      // fetchPdfBlob();
      setPdfBlobUrl(pdf);
    }
  }, [type, pdf]);

  const randomQuery = `t=${Date.now()}`;
  return (
    <div className="" id="">
      <div className="div3-header d-flex justify-content-between align-items-center">
        <h4>{caseName}</h4>
        <Tooltip id="rightbar-close" className="tooltip-custom" />
        <button
          id="closeBtn"
          onClick={toggleSidebar2}
          className="btn data-btn close-btn"
          data-tooltip-id="rightbar-close"
          data-tooltip-content={'Close'}>
          <i className="icofont-close-line"></i>
        </button>
      </div>

      <div className="main-ctn-wrapper" id="mainCtnWrapper">
        <div className="ai-response-area">
          <div className="ai-report" id="docPreview">
            <div className="d-flex justify-content-between align-items-center mb-3">

              <h4>👁️ Document Preview</h4>
            </div>
            <div className="doc-preview-wrap">
              {type === 2 ? (<>
                <div className="dc-topbar">
                  <div className="doc-name">
                    <h5>{caseName}</h5>
                  </div>
                  <div className="doc-op">
                    <Tooltip id="download-pdf" className="tooltip-custom" />
                    <a
                      className="mb-0"
                      onClick={() => downloadpdf(pdf, caseName, case_id)}
                      data-tooltip-id="download-pdf"
                      data-tooltip-content={'Download'}>
                      <i className="fa-solid fa-download"></i> Download
                    </a>
                  </div>
                </div>

                <div className="doc-preview-area">
                  <div>
                    <Iframe
                      key={`${case_id}-${pdf}`} // key ensures remounting when pdf changes
                      ref={iframeRef}
                      url={`${pdf}`} // ensure it starts from page 1
                      width="100%"
                      height="600px"
                      frameBorder="0"
                      allowFullScreen
                      onLoad={handleIframeLoad}
                    />
                  </div>
                </div>
              </>
              ) : (
                <>
                  {!loadingPdf && pdfBlobUrl && (
                    <PDFCanvasViewer
                      caseId={case_id}
                      fileUrl={pdfBlobUrl}
                      pageRange={searchitempage || '1'}
                      scale={1.5}

                    />
                  )}
                </>
              )

              }

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportPdf;
